import React from 'react';
import styles from './styles.module.scss';
import enhance from './enhance';

export const PriorityLabel = ({
  priority,
  priorityDot,
  priorityLabel,
}) => (
  <div className={styles.priorityLabel}>
    <span className={priorityDot}></span>Priority {priority}
  </div>
)

export default enhance(PriorityLabel);
